var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "fade-in-fwd", attrs: { id: "step-2" } }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12 mb-3" }, [
        _c("label", { attrs: { for: "" } }, [
          _vm._v(
            "\n        " +
              _vm._s(
                _vm.$resourceString[
                  "contentWizard.step.webPage.label.selectWebPage"
                ]
              ) +
              "\n      "
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "justify-content-between align-items-center" },
          [
            _c("div", { staticClass: "search-container d-flex flex-wrap" }, [
              _c("div", { staticClass: "input-group" }, [
                _c("input", {
                  staticClass: "form-control text-capitalize",
                  attrs: {
                    type: "search",
                    id: _vm.step2.webPageSearchTerm,
                    placeholder:
                      _vm.$resourceString[
                        "contentWizard.step.webPage.placeholder.selectWebPage"
                      ]
                  },
                  domProps: {
                    value: !_vm.getContentWizardData.selectedWebPage.pageName
                      ? _vm.step2.webPageSearchTerm.toLowerCase()
                      : _vm.getContentWizardData.selectedWebPage.pageName.toLowerCase()
                  },
                  on: {
                    input: _vm.updateSearchQuery,
                    keydown: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.submitSearch($event)
                    }
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "input-group-append" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-outline-accent-gray-alt web-page-down-btn",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.setShowAllWebPages(!_vm.showAllWebPages)
                        }
                      }
                    },
                    [
                      _vm._v("\n                 "),
                      _c("span", {
                        class: _vm.showAllWebPages
                          ? "png-icon png-icon-icons-glyph--k-chevron-up"
                          : "png-icon png-icon-icons-glyph--k-chevron-down"
                      }),
                      _vm._v(" \n              ")
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              !_vm.showAllWebPages && _vm.showSuggestions
                ? _c(
                    "ul",
                    {
                      staticClass: "search-result-box text-capitalize p-0",
                      class: _vm.step2.webPageSearchTerm ? "" : "d-none"
                    },
                    _vm._l(
                      _vm.getContentWizardData.webPagesSuggestions,
                      function(item, index) {
                        return _c(
                          "li",
                          {
                            key: index,
                            staticClass: "search-result__value p-3",
                            on: {
                              click: function($event) {
                                return _vm.selectSuggestion(item)
                              }
                            }
                          },
                          [_c("span", [_vm._v(_vm._s(item.pageName))])]
                        )
                      }
                    ),
                    0
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _vm.showAllWebPages
              ? _c("div", { staticClass: "dropdown-menu-right show p-0" }, [
                  _c(
                    "div",
                    { staticClass: "accordion search-result-box" },
                    [
                      _vm.getContentWizardData.allWebPages.length > 0
                        ? _c("AccordionChildren", {
                            attrs: {
                              webPageValue:
                                _vm.getContentWizardData.allWebPages,
                              setShowAllWebPages: _vm.setShowAllWebPages
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ])
              : _vm._e()
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm-12" }, [
        _c("label", { attrs: { for: "" } }, [
          _vm._v(
            _vm._s(
              _vm.$resourceString[
                "myProject.Project.AddItemModal.ProductStep1.ProjectGridSize.Label"
              ]
            )
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-sm-4" },
        [
          _c("my-project-radio-field", {
            attrs: {
              options: _vm.getContentWizardData.radioOptions,
              name: "size"
            },
            model: {
              value: _vm.step2.size,
              callback: function($$v) {
                _vm.$set(_vm.step2, "size", $$v)
              },
              expression: "step2.size"
            }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "form-group mt-32" },
      [
        _c(
          "label",
          { staticClass: "gray-bold", attrs: { for: "#Step2Description" } },
          [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$resourceString["common.label.description"]) +
                "\n    "
            )
          ]
        ),
        _vm._v(" "),
        _c("my-project-description-field", {
          attrs: {
            customClass: "form-control",
            maxlength: "400",
            fieldId: "description",
            placeholder:
              _vm.$resourceString[
                "myProject.ProductItem.Description.Placeholder"
              ]
          },
          model: {
            value: _vm.step2.description,
            callback: function($$v) {
              _vm.$set(_vm.step2, "description", $$v)
            },
            expression: "step2.description"
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }